import "./InsightLandingPage.scss";
import { HeroWithImageThematic } from "/App.Components";
import { DesignTheme } from "/App.GeneratedEnums";
import { InsightLandingPageProps } from "/Models/Generated/InsightLandingPageProps";
import ContentSearch from "/Components/Shared/Contentsearch/ContentSearch";

const InsightLandingPage = ({
  hiddenH1,
  pageHeader,
  insightSearchBlock,
}: InsightLandingPageProps) => {
  return (
    <div className="insight-landing-page-norad">
      {hiddenH1 && <h1 className="visually-hidden">{hiddenH1}</h1>}
      {pageHeader && (
        <HeroWithImageThematic
          {...pageHeader}
          useH2InHeader={!!hiddenH1}
          theme={DesignTheme.Insight}
        />
      )}
      {insightSearchBlock && <ContentSearch insightSearchBlock={insightSearchBlock} />}
    </div>
  );
};

export default InsightLandingPage;
